// One id per logical user action (a creation, a debundle, a sync, a count adjustment).
// It is the seed of the idempotency keys sent with every Unicommerce inventory adjustment,
// so it must be generated once per action and reused across retries of that same action —
// never regenerated per request.
export const newOperationId = (): string =>
  typeof crypto !== 'undefined' && 'randomUUID' in crypto
    ? crypto.randomUUID()
    : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
